<template>
  <v-card class="info-action-card">
    <h2 class="info-action-card__title primary--text">
      {{ title }}
    </h2>
    <div class="info-action-card__content">
      <div class="info-action-card__description primary--text">
        <slot name="description">
          <p>
            {{ description }}
          </p>
          <div class="checkbox-section">
            <v-checkbox
              v-model="acceptPOI"
              class="checkbox-section__checkbox"
            >
              <template v-slot:label>
                <p class="checkbox-section__description">
                  {{ checkboxDescription }}
                </p>
              </template>
            </v-checkbox>
          </div>
        </slot>
      </div>
    </div>
    <div
      class="info-action-card__actions"
      :class="{ 'positionLeft': isActionPositionLeft }"
    >
      <slot name="actions">
        <ads-button
          color="#CE0037"
          class="white--text snsw-button"
          :disabled="!acceptPOI"
          @click="$emit('handleAction')"
        >
          <img
            class="snsw-logo"
            src="./SNSW-logo.svg"
            alt="Service NSW"
          >
          {{ buttonTextContent }}
        </ads-button>
      </slot>
    </div>
  </v-card>
</template>

<script>
import AdsButton from '../AdsButton';

export default {
  name: 'ParentIdLogin',
  components: {
    AdsButton,
  },
  props: {
    title: {
      type: String,
      default: 'Sign in using your Service NSW account'
    },
    description: {
      type: String,
      default: 'You will be asked to verify your identity using your Service NSW account. Service NSW will share your verified name with the Department of Education.'
    },
    checkboxDescription: {
      type: String,
      default: 'I declare I am the person stated on the documents I am using for identity verification and I am aware that it is a criminal offence to provide false or misleading information to a government department.'
    },
    buttonTextContent: {
      type: String,
      default: 'Continue with Service NSW'
    },
    isActionPositionLeft: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      acceptPOI: false,
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

//small to large phone Material Design Breakpoint
@mixin mobile-xs {
  @media (max-width: 600px) {
    @content;
  }
}

.info-action-card {
  padding: 1.5rem 2rem;
  display: flex;
  flex-direction: column;

  @include mobile-xs {
    padding: 1.5rem;
  }

  button.v-btn {
    width: 19rem;
    overflow: hidden;
    text-overflow: ellipsis;

    @include mobile-xs {
      width: 100%;
    }
  }

  &__content {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }

  &__title {
    margin-bottom: 1rem;

    @include mobile-xs {
      margin-right: 0;
    }

    // font
    font-weight: 700;
    font-size: 1.375rem;
    line-height: 1.2;
  }

  &__description {
    flex: 1;
    margin-bottom: 1rem;

    // font
    font-weight: 400;
    font-size: 1rem;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    align-self: flex-end;

    @include mobile-xs {
      margin-top: 1rem;
      width: 100%;
    }

    ::v-deep .v-btn {
      & * {
        text-overflow: ellipsis;
        overflow: hidden;
      }

      width: 100%;
      height: 60px;
    }
  }

  @include mobile-xs {
    padding: 1.5rem;
  }
}

.snsw-logo {
  border: 2px solid white;
  border-radius: 50%;
  height: 2.125rem;
  margin-right: 0.75rem;
}

.checkbox-section {
  background-color: $ads-light-10;
  border-radius: 5px;

  &__checkbox {
    margin-left: 1.25rem;
    margin-right: 1.25rem;

    ::v-deep .v-input--selection-controls__input {
      align-self: start;
      margin-right: 0.75rem;
      margin-top: 1.0625rem;
    }
  }

  &__description {
    margin-top: 1.0625rem;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: $ads-dark;
  }
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) {
  color: #fff !important;
  background-color: #4c4f55 !important;
}

.positionLeft {
  align-self: flex-start;
}

</style>
